import styled, { css } from 'styled-components';
import { FontWeightSemiBold, Spacing8 } from 'autogen/design-tokens/tokens';
import { Typography } from 'components/generic/typography';

const Headline = styled(Typography.Body)<{ $isActive: boolean }>`
    display: grid;
    grid-template-areas: 'radio label price';
    grid-template-columns: 24px auto auto;
    gap: ${Spacing8};

    ${({ $isActive }) =>
        $isActive &&
        css`
            font-weight: ${FontWeightSemiBold};
        `}
`;
export default Headline;
